'use strict';

/*global app*/
/*global services*/
/*global invokeCallback*/

function OptimizationService() {
  this.$container = $('body');

  this.warehouseId = null;
  this.sectorId = null;

  this.init();
}

OptimizationService.prototype = $.extend({}, {
  constructor: 'OptimizationService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.open-optimization-optimize-locations', function () {
      _this.optimizeLocations();

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  selectWarehouse: function selectWarehouse(callback) {
    var _this = this;

    services.get('warehouse-service').selectWarehouse({ title: app.t('warehouse.title') }, function (warehouseId) {
      _this.warehouseId = warehouseId;

      invokeCallback(callback);
    });

    return _this;
  },

  selectSector: function selectSector(callback) {
    var _this = this;

    services.get('sector-service').selectSector({ title: app.t('sector.title') }, function (sectorId) {
      _this.sectorId = sectorId;

      invokeCallback(callback);
    });

    return _this;
  },

  selectItemsCount: function selectItemsCount(callback) {
    var _this = this;

    var list = [];
    for (var i = app.param('min_items_to_optimization'); i <= app.param('max_items_to_optimization'); i = i + app.param('step_items_to_optimization')) {
      list.push({
        id: i,
        abbr: i,
      });
    }

    app.selectValue({ title: app.t('optimization.items_count'), list: list }, function (itemsCount) {
      _this.itemsCount = itemsCount;

      invokeCallback(callback);
    });

    return _this;
  },

  optimizeLocations: function optimizeLocations() {
    var _this = this;

    _this.selectWarehouse(function () {
      _this.selectSector(function () {
        _this.selectItemsCount(function () {
          location.href = app.path('optimization_optimize_locations', { WarehouseId: _this.warehouseId, SectorId: _this.sectorId, ItemsCount: _this.itemsCount });
        });
      });
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

